/**
 * @file scholarships.js
 * @author Jake Stark
 * @desc Scholarships report

*/

/**
 * @module scholarships
 * @desc Scholarships report
 */

define('plugins/scholarships',["underscore",
        "models", "cardboard/models", "cardboard/collections", "cardboard/util", "cardboard/pluginPieces",
        "text!plugins/templates/scholarships_econAssistance_table.html!strip", "text!plugins/templates/scholarships_econAssistancePrior_table.html!strip", "text!plugins/templates/scholarships_scholarshipParticipation_table.html!strip"
    ],
    function (_,
        ECLDSModels, CardboardModels, CardboardCollections, Util, PluginPieces,
        econAssistanceTemplate, econAssistancePriorTemplate, scholarshipParticipationTemplate) {

        console.log("MODULE: scholarships");
        //  var colors = Highcharts.getOptions().colors;
        var colors = [Util.Color.gradients.blue1, Util.Color.gradients.green, Util.Color.gradients.blue2, Util.Color.gradients.grey2, Util.Color.gradients.purple, Util.Color.gradients.gold, Util.Color.gradients.blue3, Util.Color.gradients.cream];

        var tableClone, chartHeadClone, tableClone2, chartHeadClone2;

        var $input = [];
        var tId, hc, nId, chartHeadId;
        window.appECLDS = "true";
        var url;

        drill2 = function (options, chartId, event) {

            var myChart, myChartIndex;

            var tableCount = 0,
                //chartHeads = 0,
                notes = 0;
            console.log(options);
            console.log(chartId);

            url = "ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_n3_scholarship_drill" + options;

            $.getJSON(url, function (json) {

                var chartData = [];
                console.log(json);

                if (json.dataSets) {
                    $.each($('.eec'), function (index, value) {
                        this.setAttribute("id", "" + tableCount + "");
                        ++tableCount;
                    });

                    /* $.each($('.chartHead'), function (index, value) {
                         this.setAttribute("id", "ch" + chartHeads + "");
                         ++chartHeads;
                     });*/

                    $.each($('.noteChart'), function (index, value) {
                        this.setAttribute("id", "note" + notes + "");
                        ++notes;
                    });

                    if (chartId) {
                        hc = "#" + chartId + "";
                        for (i = 0; i < charts.length; i++) {
                            if (charts[i].container.id == chartId)
                                myChart = i;
                        }
                    } else {
                        chartId = event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling.firstChild.id;

                        for (i = 0; i < charts.length; i++) {
                            if (charts[i].container.id == chartId)
                                myChart = i;
                        }
                        hc = "#" + charts[myChart].container.id + "";
                    }

                    charts[myChart].myChartTableId = charts[myChart].container.parentElement.nextSibling.firstChild.id;

                    // charts[myChart].myChartHeadId = charts[myChart].container.parentElement.previousSibling.previousSibling.firstChild.id;

                    tId = "#" + charts[myChart].myChartTableId + "";
                    nId = "#note" + charts[myChart].myChartTableId + "";
                    // chartHeadId = "#" + charts[myChart].myChartHeadId + "";
                    //console.log(chartHeadId);

                    tableSave[charts[myChart].myChartTableId] = "<table id=" + charts[myChart].myChartTableId + " class='eec'>";

                    //  chartHeadSave[charts[myChart].myChartTableId] = "<h5 id=" + charts[myChart].myChartHeadId + " class='chartHead'>" + $(chartHeadId)[0].innerHTML + "</h5>";

                    for (i = 0; i < charts[myChart].series[0].data.length; i++)
                        chartSave[i] = jQuery.extend(true, {}, charts[myChart].series[0].data[i]);

                    while (charts[myChart].series.length > 0)
                        charts[myChart].series[0].remove();
                    var data = json.dataSets.programCombinations.data;

                    var tableContent = '<table id="' + charts[myChart].myChartTableId + '" class="eec"><thead><th>Program Combinations</th><th>Count (Percent)</th></thead>';

                    charts[myChart].options.plotOptions.column.colorByPoint = false;
                    charts[myChart].xAxis[0].update({
                        labels: {
                            enabled: false
                        }
                    });
                    charts[myChart].yAxis[0].update({
                        max: 100
                    });
                    charts[myChart].legend.options.enabled = true;

                    for (i = 0; i < data.length; i++) {
                        chartData = [];
                        chartData.push([data[i]['programCombinations'], data[i]['percent']]);
                        tableContent += "<tr><th>" + data[i]['programCombinations'] + "</th><td>" + data[i]['formattedCount'] + " " + data[i]['formattedPercent'] + "</td></tr>";
                        charts[myChart].addSeries({
                            stacking: "normal",
                            name: data[i]['programCombinations'],
                            data: chartData,
                            color: colors[i],
                            dataLabels: false
                        }, false);
                    }
                    tableContent += "</table>";

                    tableClone = $(tId).clone();

                    tableSave[charts[myChart].myChartTableId] += tableClone[0].innerHTML + "</table>";

                    $(tId).replaceWith(tableContent);
                    $(nId).replaceWith("<div id=note" + charts[myChart].myChartTableId + "><p>NOTE: Click on Back button to return to previous chart. </p> <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>");
                    tableClone = $(tId).clone();

                    var myChartString = "'" + myChart + "'";

                    var button = '<input type="button" value="Back" class="backButton" id="backButton' + charts[myChart].myChartTableId + '" onclick="restoreEecReport2(' + charts[myChart].chartId + ');"/>';

                    $input[myChart] = $(button);
                    $input[myChart].appendTo(hc);

                    //  chartHeadClone = $(chartHeadId).clone();
                    //  $(chartHeadId).replaceWith("<h5 id='" + charts[myChart].myChartHeadId + "' class='chartHead'>" + json.dataSets.programCombinations.heading + "</h5>");
                    charts[myChart].render();

                } else {
                    alert(json.meta.dataNotAvailableMessage);
                }
            });
        };

        restoreEecReport2 = function (myChartString) {

            var myChart = parseInt(myChartString);

            for (i = 0; i < charts.length; i++) {
                if (charts[i].chartId == myChart)
                    myChart = i;
            }

            var data = [];
            tId = "#" + charts[myChart].myChartTableId + "";
            nId = "#note" + charts[myChart].myChartTableId + "";

            // chartHeadId = "#" + charts[myChart].myChartHeadId + "";

            $(nId).replaceWith("<div class='noteChart'>NOTE: Click on a program to see multiple program participation counts. <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>");

            $(tId).replaceWith(tableSave[charts[myChart].myChartTableId]);
            // $(chartHeadId).replaceWith(chartHeadSave[charts[myChart].myChartTableId]);
            $input[myChart].remove();

            for (i = 0; i < chartSave.length; i++) {

                data.push({
                    name: chartSave[i]['name'],
                    y: chartSave[i]['y'],
                    x: chartSave[i]['x'],
                    color: chartSave[i]['color'],
                    allInfo: {
                        drillParm: chartSave[i]['allInfo']['drillParm']
                    }
                });
            }

            while (charts[myChart].series.length > 0)
                charts[myChart].series[0].remove();

            charts[myChart].legend.options.enabled = false;
            charts[myChart].yAxis[0].update({
                max: 50
            });
            charts[myChart].xAxis[0].update({
                labels: {
                    enabled: true
                }
            });
            charts[myChart].addSeries({
                type: "column",
                data: data,
                color: chartSave.colors,
                dataLabels: false
            }, false);
            charts[myChart].render();

        };

        drill3 = function (options, chartId, event) {

            var myChart, myChartIndex;

            var tableCount = 0,
                // chartHeads = 0,
                notes = 0;

            url = "ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_n5_scholarship_drill" + options;

            $.getJSON(url, function (json) {

                var chartData = [];
                console.log(json);

                if (json.dataSets) {
                    $.each($('.eec'), function (index, value) {
                        this.setAttribute("id", "" + tableCount + "");
                        ++tableCount;
                    });

                    /* $.each($('.chartHead'), function (index, value) {
                         this.setAttribute("id", "ch" + chartHeads + "");
                         ++chartHeads;
                     });*/

                    $.each($('.noteChart'), function (index, value) {
                        this.setAttribute("id", "note" + notes + "");
                        ++notes;
                    });

                    if (chartId) {
                        hc = "#" + chartId + "";
                        for (i = 0; i < charts.length; i++) {
                            if (charts[i].container.id == chartId)
                                myChart = i;
                        }
                    } else {
                        chartId = event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling.firstChild.id;

                        for (i = 0; i < charts.length; i++) {
                            if (charts[i].container.id == chartId)
                                myChart = i;
                        }
                        hc = "#" + charts[myChart].container.id + "";
                    }
                    console.log(charts[myChart].container.parentElement.nextSibling.firstChild.id);

                    charts[myChart].myChartTableId = charts[myChart].container.parentElement.nextSibling.firstChild.id;

                    //   charts[myChart].myChartHeadId = charts[myChart].container.parentElement.previousSibling.previousSibling.firstChild.id;

                    tId = "#" + charts[myChart].myChartTableId + "";
                    nId = "#note" + charts[myChart].myChartTableId + "";
                    // chartHeadId = "#" + charts[myChart].myChartHeadId + "";
                    //console.log(chartHeadId);

                    tableSave2[charts[myChart].myChartTableId] = "<table id=" + charts[myChart].myChartTableId + " class='eec'>";

                    //chartHeadSave2[charts[myChart].myChartTableId] = "<h5 id=" + charts[myChart].myChartHeadId + " class='chartHead'>" + $(chartHeadId)[0].innerHTML + "</h5>";

                    for (i = 0; i < charts[myChart].series[0].data.length; i++)
                        chartSave2[i] = jQuery.extend(true, {}, charts[myChart].series[0].data[i]);

                    while (charts[myChart].series.length > 0)
                        charts[myChart].series[0].remove();
                    var data = json.dataSets.programCombinations.data;

                    var tableContent = '<table id="' + charts[myChart].myChartTableId + '" class="eec"><thead><th>Program Combinations</th><th>Participation</th></thead>';

                    charts[myChart].options.plotOptions.column.colorByPoint = false;
                    charts[myChart].xAxis[0].update({
                        labels: {
                            enabled: false
                        }
                    });
                    charts[myChart].yAxis[0].update({
                        max: 100
                    });
                    charts[myChart].legend.options.enabled = true;

                    for (i = 0; i < data.length; i++) {
                        chartData = [];
                        chartData.push([data[i]['programCombinations'], data[i]['percent']]);
                        tableContent += "<tr><th>" + data[i]['programCombinations'] + "</th><td>" + data[i]['formattedCount'] + " " + data[i]['formattedPercent'] + "</td></tr>";
                        charts[myChart].addSeries({
                            stacking: "normal",
                            name: data[i]['programCombinations'],
                            data: chartData,
                            color: colors[i],
                            dataLabels: false
                        }, false);
                    }
                    tableContent += "</table>";

                    tableClone2 = $(tId).clone();

                    tableSave2[charts[myChart].myChartTableId] += tableClone2[0].innerHTML + "</table>";

                    $(tId).replaceWith(tableContent);
                    $(nId).replaceWith("<div id=note" + charts[myChart].myChartTableId + "><p>NOTE: Click on Back button to return to previous chart. </p> <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>");
                    tableClone2 = $(tId).clone();

                    var myChartString = "'" + myChart + "'";

                    var button = '<input type="button" value="Back" class="backButton" id="backButton' + charts[myChart].myChartTableId + '" onclick="restoreEecReport3(' + charts[myChart].chartId + ');"/>';

                    $input[myChart] = $(button);
                    $input[myChart].appendTo(hc);

                    // chartHeadClone2 = $(chartHeadId).clone();
                    // $(chartHeadId).replaceWith("<h5 id='" + charts[myChart].myChartHeadId + "' class='chartHead'>" + json.dataSets.programCombinations.heading + "</h5>");
                    charts[myChart].render();

                } else {
                    alert(json.meta.dataNotAvailableMessage);
                }
            });
        };

        restoreEecReport3 = function (myChartString) {

            var myChart = parseInt(myChartString);

            for (i = 0; i < charts.length; i++) {
                if (charts[i].chartId == myChart)
                    myChart = i;
            }

            var data = [];
            tId = "#" + charts[myChart].myChartTableId + "";
            nId = "#note" + charts[myChart].myChartTableId + "";

            //chartHeadId = "#" + charts[myChart].myChartHeadId + "";

            $(nId).replaceWith("<div class='noteChart'>NOTE: Click on a program to see multiple program participation counts. <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>");

            $(tId).replaceWith(tableSave2[charts[myChart].myChartTableId]);
            // $(chartHeadId).replaceWith(chartHeadSave2[charts[myChart].myChartTableId]);
            $input[myChart].remove();

            for (i = 0; i < chartSave2.length; i++) {

                data.push({
                    name: chartSave2[i]['name'],
                    y: chartSave2[i]['y'],
                    x: chartSave2[i]['x'],
                    color: chartSave2[i]['color'],
                    allInfo: {
                        drillParm: chartSave2[i]['allInfo']['drillParm']
                    }
                });
            }

            while (charts[myChart].series.length > 0)
                charts[myChart].series[0].remove();

            charts[myChart].legend.options.enabled = false;
            charts[myChart].yAxis[0].update({
                max: 50
            });
            charts[myChart].xAxis[0].update({
                labels: {
                    enabled: true
                }
            });
            charts[myChart].addSeries({
                type: "column",
                data: data,
                color: chartSave.colors,
                dataLabels: false
            }, false);
            charts[myChart].render();

        };

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                noOrgSearch: false,
                noOrgFinderSchool: true,
                orgFinderDistrict: true,
                forcedSummaryFilters: ["FISCAL_YEAR"],
                definitionsECLDS: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "Scholarships and Economic Assistance Connections",
                    explanationText: "<p>This chart shows the number and percent of children in the cohort that received at least one type of economic assistance within 12 months prior to their scholarship awards. Programs included as economic assistance are Minnesota Family Investment Program/Diversionary Work Program (MFIP/DWP), Supplemental Nutrition Assistance Program (SNAP), and Child Care Assistance (CCAP). It is recognized that children may have been receiving multiple types of assistance. The detail by economic assistance program type is available on subsequent charts.</p><p>For more information about the Early Learning Scholarships program and counts of children and families using scholarships in recent years, please refer to the Early Learning Scholarships Use in Minnesota reports found on MDE's <a href='https://education.mn.gov/MDE/dse/early/elprog/sch/' target='_blank'>Early Learning Scholarships webpage</a> in the Early Learning Scholarship Participation section.</p> ",
                    openByDefault: true,

                    views: [{
                            type: "template",
                            template: "<div><p>NOTE: This chart shows the number and percent of children that received an Early Learning Scholarship in relation to other economic assistance sources the child was receiving prior to the scholarship. </p>  <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.receivedEconomicAssistance",

                            //dataPath: "dataSets.raceAndEthnicity.data", 
                            // all paths in the
                            // chartable series are
                            // relative to this blob

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",

                            // since in this case there's only one dimension, due to
                            // there being only one series to plot, it looks like
                            // this:
                            //	 +---------+
                            //	 | X X X X |
                            //	 +---------+
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                            dataLabels: false,
                            unitDec: 1,
                            disableLegendClick: false,
                            exportToPDF: true,
                            hideContext: true,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "scholarshipRecipient",
                                longDisplayNamePath: "scholarshipRecipient"
                            }],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.receivedEconomicAssistance",
                            template: econAssistanceTemplate,
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Economic Assistance Prior to Scholarship",
                    explanationText: "<p>This chart shows the percent of children that were awarded a scholarship that had received each type of economic assistance within the 12 months prior to their scholarship award date. Programs included as economic assistance are Minnesota Family Investment Program/Diversionary Work Program (MFIP/DWP), Supplemental Nutrition Assistance Program (SNAP), and Child Care Assistance (CCAP). This is presented in relation to the total percent of children that received each type of economic assistance. It is recognized that children may have been receiving multiple types of assistance. </p> ",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5 class='chartHead'>{{data.heading}}</h5>",
                            dataSourceName: "data",
                            dataPath: "dataSets.economicAssistancePriorToScholarship"
                        },
                        {
                            type: "template",
                            template: "<div><p>NOTE: Click on a program to see multiple program counts. </p> <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.economicAssistancePriorToScholarship",
                            yAxisMax: 60,
                            title: "",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,

                            // DISPLAY
                            // xAxisLabelPath: "label",
                            unitString: "%",
                            showLegend: false,
                            colorByPoint: true,
                            unitDec: 1,
                            disableLegendClick: false,
                            exportToPDF: true,
                            hideContext: true,

                            // SERIES
                            series: [{
                                seriesDisplayNamePath: "program",
                                // seriesDisplayName: "programName",
                                dataPath: "",
                                valuePath: "percent",
                                displayNamePath: "program",
                                //  colors: ["orange", "purple", "green", "blue1"],

                            }],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: econAssistancePriorTemplate,
                            dataSourceName: "data",
                            dataSetPath: "dataSets.economicAssistancePriorToScholarship",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Scholarship Participation by Program",
                    explanationText: '<p>This chart shows children that received a scholarship and participated in at least one of the following public early care and education programs during the same year: Child Care Assistance (CCAP), Early Childhood Special Education (ECSE), Head Start, or School District Preschool (MN District Preschool). As children may use several public early education programs simultaneously or at different times, the program combinations in which a child with a scholarship participated in are visible by clicking on the detail. </p><p>Head Start data is not representative of all statewide Head Start data.</p><p>The Public Early Care and Education Program may not represent where the scholarship was used.</p><p>For total Scholarships participation counts in recent school years, explore the "Early Learning Scholarship Participation section" of the MDE Early Learning Scholarships webpage.</p',
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5 class='chartHead'>{{data.heading}}</h5>",
                            dataSourceName: "data",
                            dataPath: "dataSets.scholarshipParticipationByProgram"
                        },
                        {
                            type: "template",
                            template: "<div class='noteChart'><p>NOTE: Click on a program to see multiple program participation counts.</p> <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.scholarshipParticipationByProgram",
                            yAxisMax: 60,
                            title: "",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,

                            // DISPLAY
                            // xAxisLabelPath: "label",
                            unitString: "%",
                            showLegend: false,
                            colorByPoint: true,
                            unitDec: 1,
                            disableLegendClick: false,
                            exportToPDF: true,
                            hideContext: true,

                            // SERIES
                            series: [{
                                seriesDisplayNamePath: "program",
                                // seriesDisplayName: "programName",
                                dataPath: "",
                                valuePath: "percent",
                                displayNamePath: "program",
                                //  colors: ["orange", "purple", "green", "blue1"],

                            }],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: scholarshipParticipationTemplate,
                            dataSourceName: "data",
                            dataSetPath: "dataSets.scholarshipParticipationByProgram",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },

                {
                    title: "For More Information",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: "<p>These charts show intersections between funding sources and children receiving Early Learning Scholarships. </p> <h2> Glossary</h2><p><strong> CTSTR</strong>: Counts Too Small To Report - when results are less than 10.<br/><strong> No Data Available</strong>: No data is available for the selected criteria.<br/><strong> Scholarships</strong>: Early Learning Scholarships are awarded to eligible three and four year old children to support access to quality early education and care programs for Minnesota's low income children by bridging funding gaps and decreasing barriers. Scholarships may be used in eligible Parent Aware rated early learning programs. Visit the <a href='https://education.mn.gov/MDE/dse/early/elprog/sch/index.htm' target='_blank'>MDE Early Learning Scholarships webpage</a> for more information. <br/><strong>Minnesota Family Investment Program (MFIP) and Diversionary Work Program (DWP)</strong>:  Provide income assistance to help families with low income move to financial stability through work. MFIP is Minnesota's Temporary Assistance to Needy Families (TANF) program. DWP is a four-month program that helps parents quickly find work so that they do not need to go on MFIP. When selected looks at a child's receipt of MFIP or DWP any time prior during their kindergarten year.<br/><strong>SNAP</strong>: Supplemental Nutrition Assistance Program, formerly known as Food Stamps, helps Minnesotans with low income get the food they need for nutritious and well-balanced meals. Counts include kindergartners receiving SNAP during their kindergarten year.<br/><strong>Child Care Assistance Program</strong>: (CCAP) helps make quality child care affordable by providing financial assistance to help families with low incomes pay for child care. <br/><strong>Early Childhood Special Education</strong>: (ECSE) provides supports and services to infants, toddlers and preschool children with disabilities and their families.  <br/><strong> Head Start</strong>: Head Start supports the comprehensive development of children from birth to age 5 to promote school readiness for young children from low-income families. Head Start services include early learning, health, and family well-being. <br/><strong>MN District Preschool</strong>: Program for children age three to kindergarten entrance with the purpose of preparing children to enter kindergarten. As of June 2021, Voluntary Prekindergarten (VPK) and School Readiness Plus (SRP) data are included in the MN District Preschool data provided by MDE. School Readiness data begin with the 2013-2014 school year; VPK data begin with the 2016-2017 school year; SRP data begin with the 2017-2018 school year.</p><h2>Selection Criteria Definitions</h2><p><strong> School County</strong>: County of the location of public school of enrollment. <br/><strong>School District</strong>: School district in the state of Minnesota.<br/><strong>Economic Development Region</strong>: The 13 economic development regions within the state of Minnesota as defined by the Department of Employment and Economic Development (DEED). <br/><strong>School Year</strong>: Period of time that covers July 1 of one year through June 30 of the following. <br/><strong>Race/Ethnicity</strong>: Federal Race/Ethnicity categories are as reported by the child's education record and align with the federal <a href='https://www.govinfo.gov/content/pkg/FR-1997-10-30/pdf/97-28653.pdf' target='_blank'>Office of Management and Budget's standards</a>. <i><i>Note: While state race data is collected in K-12 education records and utilized in ECLDS Kindergarten and Third Grade reports, the same data is not yet universally collected by early care and education programs.</i> </i><br/><strong>Mother's Age at Child's Birth</strong>: Age of Mother in years at the time of the child's birth. Data is obtained from the child's birth record.<br/><strong>Child Protection Involvement</strong>: Child Protection involvement means the identified child was in a family where a child protection response was completed. A child protection response is completed when an allegation of child abuse (maltreatment) by parents/caretakers in is determined to meet statutory guidelines for a child protection assessment or investigation. Child protection intervenes with families, according to Minnesota State Statute and the <a href='https://edocs.dhs.state.mn.us/lfserver/Public/DHS-5144-ENG'  target='_blank'>Minnesota Child Maltreatment Screening Guidelines</a>, to address family functioning issues and ensure that child victims of maltreatment are safe.<br/><b>Low Birth Weight</b>: An infant who is born weighing less than 2,500 grams. Data is obtained from the child's birth record. <br/><b>Preterm Birth</b>: An infant who is born before 37 weeks gestational age as calculated from the imputed gestational age based on last menstrual period. Data is obtained from the child's birth record. </p><p> For more information, open the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde034818&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>ECLDS Data Guide. </a></p><p><strong>Early Learning Scholarships Program</strong><br/>For more information about the Early Learning Scholarships program and counts of children and families using scholarships in recent years, please refer to the Early Learning Scholarships Use in Minnesota reports found on MDE's <a href='https://education.mn.gov/MDE/dse/early/elprog/sch/' target='_blank'>Early Learning Scholarships webpage</a> in the Early Learning Scholarship Participation section."
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: ECLDSModels.ECLDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_orgid_scholarship.fex",
                    //	noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    //defaultParams: ["FISCAL_YEAR=2019"],
                    urls: {
                        //filterForReport: "data/filters.json"
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_scholarship_EcoDevRegion.fex"
                    },

                    // specify the order of filters, by name (filterUrl in database terms)
                    // filterOrder: ["IDEA_COLLECTIONS", "ECSE_OUTCOMES", "MOMS_AGE_AT_CB", "MOMS_EDLVL_AT_CB", "CR"],

                    enabled: true,
                    noViewParams: false
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_fiscal_year_scholarship.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },

                filters3: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    //   defaultParams: ["FISCAL_YEAR=2019"],
                    urls: {
                        //filterForReport: "data/filters.json"
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_scholarship.fex"
                    },

                    // specify the order of filters, by name (filterUrl in database terms)
                    // filterOrder: ["GENDER", "DISABILITY_TYPE", "HOME_LANGUAGE", "OTHER_CRITERIA"],

                    enabled: true,
                    noViewParams: false
                },

                demographicCategories: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_scholarship_nbr2.fex",
                    enabled: true,
                    modelType: CardboardCollections.DemoCatProducer,
                    noViewParams: false
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.DocumentModel,
                    // url: "/data/fakeDevEdData.json",
                    // url: "/data/fakeDevEdDataFromRob.json",
                    // url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_deveducation.fex&HSGRAD_ORGID=000101001&devEdCOHORTID=2008&RACE=_FOC_NULL&GENDER=_FOC_NULL&otherCRITERIA=_FOC_NULL",
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_n_scholarship.fex",
                    yearPath: "meta.fiscalYear",

                    enabled: true
                }
            }
        };

        return exports;
    });
